var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"mt-5":""}},[_c('v-card-text',{staticStyle:{"text-align":"center"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.migrateDatabase.apply(null, arguments)}}},[_vm._v("Migrate Database to Invoice")]),_c('span',[_vm._v(_vm._s(_vm.message))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }